import { useHeadlessLaunch } from './useHeadlessLaunch'
import { useIngestWizard } from './useIngestWizard'

/**
 * Keeps every active run's server-owned progress reflected in the UI even when
 * its Step 04 route is not open. This component only observes; the api-service
 * coordinator advances jobs.
 */
export function IngestWizardCoordinator() {
  const wizard = useIngestWizard()
  const runIds = wizard.drafts
    .filter((draft) => draft.queueStarted && !draft.run.paused)
    .map((draft) => draft.draftId)

  return runIds.map((draftId) => <IngestRunCoordinator key={draftId} draftId={draftId} />)
}

function IngestRunCoordinator({ draftId }: { draftId: string }) {
  const wizard = useIngestWizard(draftId)
  useHeadlessLaunch(wizard)
  return null
}
